import React, { FunctionComponent } from 'react';

// import the icons locally embedded in Cosmos
import AssetsStoreLocal from './asset-store-local';
import assetStore from 'cosmos-assets-badoo-mobile/badoo/Assets';

type CosmosIconName = keyof typeof assetStore;
type LocalIconName = keyof typeof AssetsStoreLocal;

export type AssetSyncName = CosmosIconName | LocalIconName;

export type AssetSyncProps = {
    /**
     * Name of the required asset
     */
    name: AssetSyncName;
    /**
     * SVG preserveAspectRatio attribute
     * @notice be very careful in the usage of this attribute, it may lead to unexpected results, so use it only if 100% needed and you're sure of what you're doing
     */
    preserveAspectRatio?: string;
};

const AssetSync: FunctionComponent<AssetSyncProps> = ({ name, preserveAspectRatio }) => {
    // TODO: discuss possibility of showing icons depending on ab-test (In MW this is getAssetInfoFromSegmentation)
    const FoundLocalAsset = AssetsStoreLocal[name as LocalIconName];
    const FoundAsset = assetStore[name as CosmosIconName];

    if (FoundLocalAsset) {
        return <FoundLocalAsset />;
    }

    return <FoundAsset preserveAspectRatio={preserveAspectRatio} />;
};

export default AssetSync;
